var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16671 8.83333C2.62694 8.83333 3.00004 8.46023 3.00004 7.99999C3.00004 7.53976 2.62694 7.16666 2.16671 7.16666C1.70647 7.16666 1.33337 7.53976 1.33337 7.99999C1.33337 8.46023 1.70647 8.83333 2.16671 8.83333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16671 2.99999C2.62694 2.99999 3.00004 2.6269 3.00004 2.16666C3.00004 1.70642 2.62694 1.33333 2.16671 1.33333C1.70647 1.33333 1.33337 1.70642 1.33337 2.16666C1.33337 2.6269 1.70647 2.99999 2.16671 2.99999Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16671 14.6667C2.62694 14.6667 3.00004 14.2936 3.00004 13.8333C3.00004 13.3731 2.62694 13 2.16671 13C1.70647 13 1.33337 13.3731 1.33337 13.8333C1.33337 14.2936 1.70647 14.6667 2.16671 14.6667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.140bbf00d9913704b4b6030f8e989175.svg";
export { ForwardRef as ReactComponent };